module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-count-down",
    style: ({
      background: _vm.wrapBackground,
      color: _vm.wrapColor
    })
  }, [_c('div', {
    staticClass: "content",
    class: {
      'absolute': _vm.backgroundImage
    }
  }, [_vm._t("default"), (_vm.days > 0) ? _c('span', {
    style: ({
      background: _vm.spanBackground
    })
  }, [_vm._v(_vm._s(_vm.days))]) : _vm._e(), (_vm.days > 0) ? _c('em', [_vm._v(_vm._s(_vm.showType == 1 ? ':' : '天'))]) : _vm._e(), _c('span', {
    style: ({
      background: _vm.spanBackground
    })
  }, [_vm._v(_vm._s(_vm.hours))]), _vm._v(_vm._s(_vm.showType == 1 ? ':' : '时')), _c('span', {
    style: ({
      background: _vm.spanBackground
    })
  }, [_vm._v(_vm._s(_vm.minutes))]), _vm._v(_vm._s(_vm.showType == 1 ? ':' : '分')), _c('span', {
    style: ({
      background: _vm.spanBackground
    })
  }, [_vm._v(_vm._s(_vm.seconds))]), _vm._v(_vm._s(_vm.showMs == true ? '.' : '')), (_vm.showMs) ? _c('span', {
    style: ({
      background: _vm.spanBackground
    })
  }, [_vm._v(_vm._s(_vm.mseconds))]) : _vm._e(), _vm._v(_vm._s(_vm.showType == 1 ? '' : '秒') + "\n    ")], 2), _vm._v(" "), (_vm.backgroundImage) ? _c('img', {
    staticClass: "bgimg",
    attrs: {
      "src": _vm.backgroundImage
    }
  }) : _vm._e()])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6be32f92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-6be32f92!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/countDown/count-down.vue
// module id = 38
// module chunks = 0